import {defineStore, storeToRefs} from 'pinia';
import {ref} from '#imports';
import {Configuration, PublicSimilarProfilesApi, type SimilarProfile} from '@api';
import {useProfileStore} from '~/store/profileStore';

export const useSimilarProfileStore = defineStore('similar-profiles', () => {
    const apiConfiguration = new Configuration({basePath: ''});
    const similarProfilesApi = new PublicSimilarProfilesApi(apiConfiguration);

    const {profile} = storeToRefs(useProfileStore());

    const similarProfiles = ref<SimilarProfile[]>([]);

    async function getSimilarProfiles(): Promise<SimilarProfile[]> {
        const response = await similarProfilesApi.getSimilarProfiles({profileId: profile.value!.profileId});
        similarProfiles.value = response.similarProfiles;
        return similarProfiles.value;
    }

    return {
        similarProfiles,
        getSimilarProfiles,
    };
});
